import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { FaFacebookF, FaInstagram, FaLinkedin } from "react-icons/fa";
import { FaWhatsappSquare } from 'react-icons/fa';
import logo from '../assets/logo.png'
import '../css/Footer.css'


const Footer = () => {
    return (
        <>
            <footer className='footer text-white pt-5 pb-2'>
                <Container>
                    {/* main-content */}
                    <Row className='align-items-start text-center text-md-start'>
                        {/* left */}
                        <Col md={4} className='mb-4 mb-md-0'>
                            <Link className="navbar-brand text-white fw-bold" to="/">
                                <img src={logo} alt="logo" style={{ height: "40px" }} />
                            </Link>
                            <Link to='/' className='navbar-brand text-white fw-bold fs-3 pt-4'>SKY<span className='text-info'>GUARD</span></Link>
                            <p className='footer-desc mt-3'>SkyGuard Water Purify Services is committed to delivering top-notch water purification solutions <br />tailored to your needs. Specializing in water purifiers,<br /> we guarantee clean, safe, and healthy drinking<br /> water for you and your loved ones.</p>
                        </Col>
                        {/* middle */}
                        <Col md={4} className='mb-4 mb-md-0'>
                            <h5 className='mb-3'>Our Information</h5>
                            <ul className='footer-links list-unstyled'>
                                <li><Link to='/'>Home</Link></li>
                                <li><Link to='/contact'>Contact Us</Link></li>
                                <li><Link to='/careers'>Careers</Link></li>
                                <li><Link to='/privacy-policy'>Privacy & Policy</Link></li>
                            </ul>
                        </Col>
                        {/* right */}
                        <Col md={4} className='text-center text-md-end'>
                            <h5 className='mb-3'>Social Media</h5>
                            <div className='social-icons mb-3'>
                                <Link to='https://www.facebook.com/people/Star-Signature-Service/61555825394853/' target='_blank'><FaFacebookF size={22} /></Link>
                                <Link to='https://www.instagram.com/star.signatureservices/?igsh=aHh4b3FseHB1cTlq#' target='_blank'><FaInstagram size={22} /></Link>
                                <Link to='https://www.linkedin.com/in/harendra-kumar-yadav-4384a12b2/' target='_blank'><FaLinkedin size={22} /></Link>
                                <Link to='https://wa.me/9975990399' target="_blank"><FaWhatsappSquare size={22} /></Link>
                            </div>
                        </Col>
                    </Row>
                    {/* bottom */}
                    <Row className='pt-4'>
                        <Col className='text-center'>
                            <small>© {new Date().getFullYear()} SKY<span className='text-info'>GUARD</span>. All rights reserved.</small>
                        </Col>
                    </Row>
                </Container>
            </footer>
        </>
    )
}

export default Footer